<template>
  <div id="app">
    <div id="nav">
      <navbar style="margin-bottom:100px" v-show="!contentOnly"></navbar>
      
    </div>
    <router-view style="margin-bottom:100px"/>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
export default {
  data(){
    return{
      contentOnly:false,
    }
  },
  components:{Navbar},
  methods:{
    checkLayout(route) {
			if(route && route.meta && route.meta.contentOnly)
				this.contentOnly = true
			else 
				this.contentOnly = false
		}
  },
  created()
  {
    this.checkLayout(this.$router.currentRoute);
    this.$router.beforeEach((to, from, next) => {
			this.checkLayout(to)
			next()
		})
  }
  
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#nav {
  padding: 0px;
}


#nav a.router-link-exact-active {
  color: #2f37d3;
}
</style>
